/* eslint-disable react/jsx-no-target-blank */
import React from "react";

interface Props {
  link: string;
  title: string;
}

const ResourceLink = ({ link, title }: Props) => (
  <li
    className="item"
    style={{
      display: "block",
    }}
  >
    <i className="icon-book-open" />
    <a className="description" href={link} title={title} target="_blank">
      {title}
    </a>
  </li>
);

export default ResourceLink;
